import React from "react";
import { Container, Row } from "react-bootstrap";

const BasicQuestion = ({ question, answers }) => {
    return (
        <>
            <h2>{question}</h2>
            <Container className="px-0" fluid="lg">
                <Row>{answers}</Row>
            </Container>
        </>
    );
};

export default BasicQuestion;
